/**
 * Presentation for AMS in-app notification types.
 *
 * `notif_type` is a free varchar in public.notifications on purpose — a new producer can raise
 * a new type without a back-end release. These maps only decorate the known ones; anything
 * unrecognised falls back to DEFAULT_NOTIF_* so an unmapped type still renders correctly.
 *
 * AMS has no notification producers yet, so this is a deliberately small, generic starting set.
 * Extend it (and NOTIF_TYPE_OPTIONS follows automatically) as real AMS events get wired.
 */

export const NOTIF_TYPE_LABEL: {[key: string]: string} = {
  ANNOUNCEMENT: 'Announcement',
  ALERT: 'Alert',
  REMINDER: 'Reminder',
  APPROVAL: 'Approval',
}

export const NOTIF_TYPE_TONE: {[key: string]: string} = {
  ANNOUNCEMENT: 'info',
  ALERT: 'danger',
  REMINDER: 'warning',
  APPROVAL: 'primary',
}

export const NOTIF_TYPE_ICON: {[key: string]: string} = {
  ANNOUNCEMENT: 'campaign',
  ALERT: 'warning',
  REMINDER: 'schedule',
  APPROVAL: 'task_alt',
}

export const DEFAULT_NOTIF_TONE = 'secondary'
export const DEFAULT_NOTIF_ICON = 'notifications'

export const NOTIF_TYPE_OPTIONS = Object.keys(NOTIF_TYPE_LABEL).map((id) => ({
  id,
  title: NOTIF_TYPE_LABEL[id],
}))

export const notifTone = (notifType?: string) => NOTIF_TYPE_TONE[notifType || ''] || DEFAULT_NOTIF_TONE
export const notifIcon = (notifType?: string) => NOTIF_TYPE_ICON[notifType || ''] || DEFAULT_NOTIF_ICON
export const notifLabel = (notifType?: string) => NOTIF_TYPE_LABEL[notifType || ''] || notifType || '—'
